import { useMutation } from "@pinia/colada";

import { toApiLocale, useWidgetContext } from "@/shared/config";
import { useApiGetWidgetData } from "@/shared/model";

import { apiRegisterDevice } from "../api";
import { useEvaluationStore } from "./evaluation";

/** Зарегистрировать сдаваемое устройство для оценки (useRegisterProduct в v2) */
export function useApiRegisterDevice() {
    const { settings } = useWidgetContext();
    const { data: widgetData } = useApiGetWidgetData();
    const evaluationStore = useEvaluationStore();

    return useMutation({
        mutation: (productId: string) =>
            apiRegisterDevice({
                productId,
                token: widgetData.value?.token ?? "",
                lang: toApiLocale(settings.locale),
                // Trade-in without a purchased device: there is no article of the partner's good
                article: "",
            }),
        onSuccess: (device) => evaluationStore.setRegisteredDevice(device),
    });
}
